<!--
Обертка для компонента v-data-table от vuetify.
 -->
<template>
  <v-data-table
    v-bind="$attrs"
    :headers="localesHeaders"
    :loading-text="$attrs['loading-text'] ? t(String($attrs['loading-text'])) : $attrs['loading-text']"
    :no-data-text="$attrs['no-data-text'] ? t(String($attrs['no-data-text'])) : $attrs['no-data-text']"
  >
    <template
      v-for="(_, slot) of $slots"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope || {}"
      />
    </template>
  </v-data-table>
</template>


<script setup>
import { useDefaults } from 'vuetify'
import { computed } from 'vue';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  headers: {
    type: Array,
    required: false,
    default: []
  },
});

const localesHeaders = computed(() => {
  const headers = [];

  props.headers.forEach(header => {
    headers.push({
      ...header,
      title: header.title ? t(header.title) : header.title,
    })
  })

  return headers;
})

defineOptions({
  inheritAttrs: false
})

useDefaults()
</script>

<style scoped>
</style>